import { MijnRoute } from '../mijn-navigatie.model';

export const ADDRESS_BOOK: MijnRoute = {
    path: 'adresboek',
    navigationEvent: 'toAdresboek',
    regex: /^\/adresboek$/,
    webcomponent: 'mijn-klant-adresboek-webcomponent'
};
